import { generator } from '@philips-emr/tws-core/lib/client/event-listener';

const HPMSOnCreateOption = generator('onCreateOption');
const HPMSOnOptionClick = generator('onOptionClick');
const HPMSOnCreateMenu = generator('onCreateMenu');
const HPMSOnRenderAction = generator('onRenderAction');
const HPMSOnSubmitCard = generator('onSubmitCard');
const HPMSOnOpenCollapse = generator('onOpenCollapse');
const HPMSOnOpen = generator('onOpen');
const HPMSOnClickActionTitle = generator('onClickActionTitle');

export {
  HPMSOnCreateOption,
  HPMSOnOptionClick,
  HPMSOnCreateMenu,
  HPMSOnRenderAction,
  HPMSOnSubmitCard,
  HPMSOnOpenCollapse,
  HPMSOnOpen,
  HPMSOnClickActionTitle,
};
